/* eslint-disable no-console */

/**
 * @module M/control/ManageiseControl
 */

import ManageiseImplControl from 'impl/manageisecontrol';
import template from 'templates/manageise';
import Choices from 'choices.js';

export default class ManageiseControl extends M.Control {
  /**
   * @classdesc
   * Main constructor of the class. Creates a PluginControl
   * control
   *
   * @constructor
   * @extends {M.Control}
   * @api stable
   */
  constructor(config) {
    // 1. checks if the implementation can create PluginControl
    if (M.utils.isUndefined(ManageiseImplControl)) {
      M.exception('La implementación usada no puede crear controles ManageiseControl');
    }
    // 2. implementation of this control
    const impl = new ManageiseImplControl();
    super(impl, 'Manageise');

    this.groupLayers = config;

    //  ESTILO DE ELEMENTO RESALTADO

    this.style_select_feature_table_polygon = new M.style.Polygon({
      fill: {
        color: '#43fd1e',
        opacity: 0.2
      },
      stroke: {
        color: '#43fd1e',
        width: 6
      }
    });

    this.style_select_feature_table_line = new M.style.Line({
      stroke: {
        color: '#43fd1e',
        width: 6
      }
    });

    this.style_select_feature_table_point = new M.style.Point({
      radius: 30,
      fill: {
        color: '#43fd1e',
        opacity: 0.2
      },
      stroke: {
        color: '#43fd1e',
        width: 6
      }
    });

    //  CAPA SELECCION DE ELEMENTOS

    this.SeleccionElementos_layer = new M.layer.GeoJSON({
      name: 'Capa Seleccion de Elementos',
      source: {
        crs: {
          "type": "name",
          "properties": {
            "name": "urn:ogc:def:crs:EPSG::25830"
          }
        },
        features: [],
        type: "FeatureCollection"
      }
    });

    //  ESTILO NO VISIBLE PARA CAPAS GEOJSON DE BUSQUEDA 

    this.hiddenStyle = new M.style.Polygon({
      fill: {
        color: '#ff0000',
        opacity: 0
      }
    });

    //  CAPA DE ZONA SELECCIONADA

    this.zoneSelected = new M.layer.GeoJSON({
      name: 'Zona Seleccionada',
      source: {
        crs: {
          "type": "name",
          "properties": {
            "name": "urn:ogc:def:crs:EPSG::25830"
          }
        },
        features: [],
        type: "FeatureCollection"
      }
    });

    this.style_zoneSelected = new M.style.Polygon({
      stroke: {
        color: '#007932',
        width: 6
      }
    });

    this.zoneSelected.setStyle(this.style_zoneSelected);


  }

  /**
   * This function creates the view
   *
   * @public
   * @function
   * @param {M.Map} map to add the control
   * @api stable
   */
  createView(map) {
    if (!M.template.compileSync) { // JGL: retrocompatibilidad Mapea4
      M.template.compileSync = (string, options) => {
        let templateCompiled;
        let templateVars = {};
        let parseToHtml;
        if (!M.utils.isUndefined(options)) {
          templateVars = M.utils.extends(templateVars, options.vars);
          parseToHtml = options.parseToHtml;
        }
        const templateFn = Handlebars.compile(string);
        const htmlText = templateFn(templateVars);
        if (parseToHtml !== false) {
          templateCompiled = M.utils.stringToHtml(htmlText);
        } else {
          templateCompiled = htmlText;
        }
        return templateCompiled;
      };
    }

    return new Promise((success, fail) => {
      const html = M.template.compileSync(template);
      // Añadir código dependiente del DOM

      this.urlMunicipios = 'https://www.ideandalucia.es/services/DERA_g13_limites_administrativos/wfs?service=WFS&version=2.0.0&request=GetFeature&typename=DERA_g13_limites_administrativos:g13_01_TerminoMunicipal&propertyName=cod_mun,nombre,provincia&outputFormat=application/json';

      this.urlMunicipiosGeom = 'https://www.ideandalucia.es/services/DERA_g13_limites_administrativos/wfs?service=WFS&version=2.0.0&request=GetFeature&typename=g13_01_TerminoMunicipal&propertyName=geom&srsname=EPSG:25830&outputFormat=application/json';
      this.urlProvinciasGeom = 'https://www.ideandalucia.es/services/DERA_g13_limites_administrativos/wfs?service=WFS&version=2.0.0&request=GetFeature&typename=g13_01_Provincia&propertyName=geom&srsname=EPSG:25830&outputFormat=application/json'

      this.geomZone;

      this.zIndexToCharge = 2000;

      this.listFullMunicipios = new Array();

      this.arrayFoundLayers = new Array();

      this.divMenus = html.querySelectorAll('div#divCapas')[0];

      this.divNoCapas = html.querySelectorAll('div#noCapas')[0];



      this.map_.addLayers(this.SeleccionElementos_layer);

      this.map_.addLayers(this.zoneSelected);



      this.addMenus();

      this.addEvents(html);



      this.getMuniProv();

      success(html);
    });
  }

  /**
   * This function is called on the control activation
   *
   * @public
   * @function
   * @api stable
   */
  activate() {
    // calls super to manage de/activation
    super.activate();
  }
  /**
   * This function is called on the control deactivation
   *
   * @public
   * @function
   * @api stable
   */
  deactivate() {
    // calls super to manage de/activation
    super.deactivate();
  }
  /**
   * This function gets activation button
   *
   * @public
   * @function
   * @param {HTML} html of control
   * @api stable
   */
  getActivationButton(html) {
    return html.querySelector('.m-manageise button');
  }

  /**
   * This function compares controls
   *
   * @public
   * @function
   * @param {M.Control} control to compare
   * @api stable
   */
  equals(control) {
    return control instanceof ManageiseControl;
  }

  // Add your own functions

  getMuniProv() {
    M.remote.get(encodeURI(this.urlMunicipios)).then((res) => {
      let listMunicipios = JSON.parse(res.text).features;

      listMunicipios.forEach((municipio) => {
        if (this.listFullMunicipios.filter(obj => obj.provincia == municipio.properties.provincia).length == 0) {
          let reg = {
            provincia: municipio.properties.provincia,
            codProv: municipio.properties.cod_mun.slice(0, 2),
            municipios: [{
              cod_mun: municipio.properties.cod_mun,
              nombre: municipio.properties.nombre
            }]
          }
          this.listFullMunicipios.push(reg);
        } else {
          let reg = {
            cod_mun: municipio.properties.cod_mun,
            nombre: municipio.properties.nombre
          };
          this.listFullMunicipios.filter(obj => obj.provincia == municipio.properties.provincia)[0].municipios.push(reg);
        }
      });
    }).then(() => {

      this.choices_selectProvincias.setChoices(this.createSelectOptionsProvincias());
      this.choices_selectMunicipios.setChoices(this.createSelectOptionsMunicipios());

    });

  }

  createSelectOptionsProvincias() {
    let selectOptions = new Array();
    for (let prov of this.listFullMunicipios) {
      let option = {
        value: prov.provincia,
        label: prov.provincia,
        selected: false,
        disbled: false,
      }
      selectOptions.push(option);
    }
    return selectOptions;
  }

  createSelectOptionsMunicipios() {
    let selectOptions = new Array();
    if (this.choices_selectProvincias.getValue(true).length == 0) {
      for (let prov of this.listFullMunicipios) {
        for (let mun of prov.municipios) {
          let option = {
            value: mun.nombre,
            label: mun.nombre,
            selected: false,
            disbled: false
          }
          selectOptions.push(option);
        }
      }
    } else {
      for (let provSelected of this.choices_selectProvincias.getValue(true)) {
        let prov = this.listFullMunicipios.filter(obj => obj.provincia == provSelected)[0];
        for (let mun of prov.municipios) {
          let option = {
            value: mun.nombre,
            label: mun.nombre,
            selected: false,
            disbled: false
          }
          selectOptions.push(option);
        }
      }
    }
    return selectOptions;
  }

  addMenus() {

    let firstElementClass = ' firstElem';
    let addMenus = '<h2>Capas disponibles - ISE</h2>\n';

    this.groupLayers.forEach(groupLayer => {

      addMenus += "<div id='" + groupLayer.groupName + "' class='GroupISE" + firstElementClass + "'>\n<div class='divTitle'>\n<h3 id='title_" + groupLayer.groupName + "' class= 'groupClosed' title='Despliega las capas de " + groupLayer.groupLegend + "'>" + groupLayer.groupLegend + "</h3>\n<button class='g-cartografia-papelera' title='Elimina todas las capas seleccionadas del grupo " + groupLayer.groupLegend + "'></button>\n</div>\n<div id='layers_" + groupLayer.groupName + "' class='layersGroupISE oculta'>\n";

      addMenus += "</div>\n</div>\n"
      firstElementClass = '';
    });

    this.divMenus.innerHTML = addMenus;

    this.groupLayers.forEach(groupLayer => {
      let addLayers = "";
      let createSubgroup = true;
      let nameSubGroup = false;
      groupLayer.layers.forEach(layer => {
        if (layer.group_2 && createSubgroup) {
          // crea inicio del subgrupo aqui          
          let flatName = layer.group_2.replaceAll('á', 'a').replaceAll('é', 'e').replaceAll('í', 'i').replaceAll('ó', 'o').replaceAll('ú', 'u').replaceAll(',', '_').replaceAll(' ', '_');
          addLayers += "<div id='SubGroup_" + flatName + "' class='subGroupISE'>\n<h4 id='title_" + flatName + "' class='subGroupClosed' title='Despliega la capas de " + layer.group_2 + "'>" + layer.group_2 + "</h4>\n<div id='layers_SubGroup_" + flatName + "' class='layersSubGroupISE subGroupOculta'>";
          createSubgroup = false;
          nameSubGroup = layer.group_2;
        }
        if (nameSubGroup != layer.group_2) {
          // crea el cierra del subgrupo aqui
          addLayers += "\n</div>\n</div>";

          if (layer.group_2) {
            // crea inicio del subgrupo aqui            
            nameSubGroup = layer.group_2;
            let flatName = layer.group_2.replaceAll('á', 'a').replaceAll('é', 'e').replaceAll('í', 'i').replaceAll('ó', 'o').replaceAll('ú', 'u').replaceAll(',', '_').replaceAll(' ', '_');
            addLayers += "<div id='SubGroup_" + flatName + "' class='subGroupISE'>\n<h4 id='title_" + flatName + "' class='subGroupClosed' title='Despliega la capas de " + layer.group_2 + "'>" + layer.group_2 + "</h4>\n<div id='layers_SubGroup_" + flatName + "' class='layersSubGroupISE subGroupOculta'>";
          } else {
            nameSubGroup = false;
          }
        }

        if (layer.group_2) {
          addLayers += "<div id='ISELayer_" + layer.name + "' class='ISELayer2'>\n<p title='Añade la capa " + layer.legend + " al mapa'>" + layer.legend + "</p>\n</div>\n"
        } else {
          addLayers += "<div id='ISELayer_" + layer.name + "' class='ISELayer'>\n<p title='Añade la capa " + layer.legend + " al mapa'>" + layer.legend + "</p>\n</div>\n";
        }

      });

      let flatName = groupLayer.groupName.replaceAll('á', 'a').replaceAll('é', 'e').replaceAll('í', 'i').replaceAll('ó', 'o').replaceAll('ú', 'u').replace(',', '_').replaceAll(' ', '_');
      this.divMenus.querySelectorAll('div#layers_' + flatName)[0].innerHTML = addLayers;

    });

    setTimeout(() => {
      this.addEventsMenus();
    }, 10);
  }

  addEvents(html) {
    this.pest_divMenus = html.querySelectorAll('label#pest_divMenus')[0];
    this.pest_divCapasCargadas = html.querySelectorAll('label#pest_divCapasCargadas')[0];
    this.pest_divBusqueda = html.querySelectorAll('label#pest_divBusqueda')[0];


    this.divCapasCargadas = html.querySelectorAll('div#divCapasCargadas')[0];
    this.divBusqueda = html.querySelectorAll('div#divBusqueda')[0];
    this.divResultados = html.querySelectorAll('div#divResultados')[0];
    this.foundData = html.querySelectorAll('div#foundData')[0];
    this.selectMunicipios = html.querySelectorAll('select#selectMunicipios')[0];
    this.selectProvincias = html.querySelectorAll('select#selectProvincias')[0];

    this.loadButton = html.querySelectorAll('button#loadButton')[0];
    this.clearButton = html.querySelectorAll('button#clearButton')[0];

    this.panelsBottomRight = this.map_.getPanels().filter(obj => obj.position == '.m-bottom.m-right');

    // MOVEMOS LOS PANELES YA QUE EL PANEL DE MANAGEISE ESTARÁ ABIERTO AL INICIO
    this.panelsBottomRight.forEach(panel => {
      panel.getTemplatePanel().classList.toggle('panelBottomRightOpened');
    });


    this.pest_divMenus.addEventListener('click', () => {
      if (!this.pest_divMenus.classList.contains('actived')) {
        this.divBusqueda.style.display = 'none';
        this.divCapasCargadas.style.display = 'none';
        this.divMenus.style.display = 'block';
        let pestAct = document.querySelectorAll('label.actived')[0];
        pestAct.classList.toggle('pest_legend');
        pestAct.classList.toggle('actived');
        this.pest_divMenus.classList.toggle('pest_legend');
        this.pest_divMenus.classList.toggle('actived');
      }
    });

    this.pest_divCapasCargadas.addEventListener('click', () => {
      if (!this.pest_divCapasCargadas.classList.contains('actived')) {
        this.divBusqueda.style.display = 'none';
        this.divMenus.style.display = 'none';
        this.divCapasCargadas.style.display = 'block';
        let pestAct = document.querySelectorAll('label.actived')[0];
        pestAct.classList.toggle('pest_legend');
        pestAct.classList.toggle('actived');
        this.pest_divCapasCargadas.classList.toggle('pest_legend');
        this.pest_divCapasCargadas.classList.toggle('actived');
      }
    });

    this.pest_divBusqueda.addEventListener('click', () => {
      if (!this.pest_divBusqueda.classList.contains('actived')) {
        this.divMenus.style.display = 'none';
        this.divCapasCargadas.style.display = 'none';
        this.divBusqueda.style.display = 'block';
        let pestAct = document.querySelectorAll('label.actived')[0];
        pestAct.classList.toggle('pest_legend');
        pestAct.classList.toggle('actived');
        this.pest_divBusqueda.classList.toggle('pest_legend');
        this.pest_divBusqueda.classList.toggle('actived');
      }
    });


    // CHOICES

    this.choices_selectProvincias = new Choices(this.selectProvincias, { allowHTML: true, choices: [], closeDropdownOnSelect: true, removeItemButton: true, placeholderValue: 'Provincia', itemSelectText: 'Seleccione', noResultsText: 'No se han encontrado resultados', noChoicesText: 'No hay mas opciones', });

    this.choices_selectMunicipios = new Choices(this.selectMunicipios, { allowHTML: true, choices: [], closeDropdownOnSelect: true, removeItemButton: true, placeholderValue: 'Municipio', itemSelectText: 'Seleccione', noResultsText: 'No se han encontrado resultados', noChoicesText: 'No hay mas opciones', });

    this.selectProvincias.addEventListener('change', (evt) => {
      let prov = evt.detail.value;

      let listSelectedMun = this.choices_selectMunicipios.getValue(true);

      let listMunDeletedProv = this.listFullMunicipios.filter(obj => obj.provincia == prov)[0].municipios;

      //  Si en los municipios seleccionados está alguno que pertenece a la provincia eliminada se elimina de la selección de municipios

      listSelectedMun.forEach((muniSelected) => {
        if (listMunDeletedProv.filter(obj => obj.nombre == muniSelected).length != 0) {
          this.choices_selectMunicipios.removeActiveItemsByValue(muniSelected);
        }
      });

      this.choices_selectMunicipios.clearChoices();
      this.choices_selectMunicipios.setChoices(this.createSelectOptionsMunicipios());
    });

    this.selectMunicipios.addEventListener('change', (evt) => {
      let mun = evt.detail.value;
      let prov;
      let selectecMunicipios = this.choices_selectMunicipios.getValue(true);
      for (let p of this.listFullMunicipios) {
        if (p.municipios.filter(obj => obj.nombre == mun).length != 0) {
          prov = p.provincia;
        }
      }

      if (selectecMunicipios.includes(mun)) {   // El municipio se ha añadido
        // si la provincia del municipio seleccionado no está seleccionada la selecciona automáticamente
        if (!this.choices_selectProvincias.getValue(true).includes(prov)) {
          this.choices_selectProvincias.setChoiceByValue(prov);
        }
      } else {    // El municipio se ha eliminado
        let checkeaProvincia = false;
        let listMuniByProvSelected = this.listFullMunicipios.filter(obj => obj.provincia == prov)[0].municipios;

        for (let m of selectecMunicipios) {
          if (listMuniByProvSelected.filter(obj => obj.nombre == m).length != 0) {
            checkeaProvincia = true;
          }
        }

        // si hay alguna provincia seleccionada sin ningún municipio seleccionado la elimina automáticamente
        if (!checkeaProvincia) {
          this.choices_selectProvincias.removeActiveItemsByValue(prov);
          this.choices_selectMunicipios.clearChoices();
          this.choices_selectMunicipios.setChoices(this.createSelectOptionsMunicipios());
        }
      }

    });

    this.loadButton.addEventListener('click', () => {
      if (!this.choices_selectProvincias.input.isDisabled && !this.choices_selectMunicipios.input.isDisabled) {
        let selectedProvincias = this.choices_selectProvincias.getValue(true);
        let selectedMunicipios = this.choices_selectMunicipios.getValue(true);
        let layerSelected = [];
        let miGeometria = false;


        //  recuperamos los nombres de las capas ISE cargadas al mapa
        document.querySelectorAll('div.layerSelected').forEach((elem) => {
          layerSelected.push(elem.id.replace('ISELayer_', ''));
        });

        if (selectedProvincias.length == 0 && selectedMunicipios.length == 0 && layerSelected.length == 0) {
          M.dialog.info('<p>Atención:</p><p>Debe seleccionar al menos un Municipio o una Provincia y Capas sobre las que realizar la búsqueda</p>');
        }
        if (selectedProvincias.length == 0 && selectedMunicipios.length == 0 && layerSelected.length != 0) {
          M.dialog.info('<p>Atención:</p><p>Debe seleccionar al menos un Municipio o una Provincia sobre las que realizar la búsqueda en las Capas seleccionadas</p>');
        }
        if ((selectedProvincias.length != 0 || selectedMunicipios.length != 0) && layerSelected.length == 0) {
          M.dialog.info('<p>Atención:</p><p>Debe seleccionar al menos una Capa sobre las que realizar la búsqueda en la zona seleccionada</p>');
        }
        if ((selectedProvincias.length != 0 || selectedMunicipios.length != 0) && layerSelected.length != 0) {


          layerSelected.forEach((layer) => {
            this.groupLayers.forEach((groupLayer) => {
              let foundLayer = groupLayer.layers.filter(obj => obj.name == layer);
              if (foundLayer.length != 0) {
                this.arrayFoundLayers.push(foundLayer[0]);
              }
            });
          });

          this.choices_selectProvincias.disable();
          this.choices_selectMunicipios.disable();

          //  añadimos contenedor_cargandoPagina

          let contenedor = document.createElement('div');
          contenedor.id = 'contenedor_cargandoPagina';

          contenedor.innerHTML = '<div id="div_loader">\n<span class="loader"></span>\n<div id="count_loader" class="parpadeo">Buscando datos</div>\n</div>';

          document.body.appendChild(contenedor);

          setTimeout(() => {
            if (selectedMunicipios.length != 0) {
              let cql_filter = '&cql_filter=nombre IN (';

              selectedMunicipios.forEach((mun) => {
                cql_filter += "'" + mun + "',";
              });

              cql_filter = cql_filter.slice(0, -1);
              cql_filter += ')';

              M.remote.get(encodeURI(this.urlMunicipiosGeom + cql_filter)).then((res) => {
                let result = JSON.parse(res.text);


                miGeometria = {
                  'type': 'MultiPolygon',
                  'coordinates': []
                }

                result.features.forEach((feature) => {

                  feature.geometry.coordinates.forEach((polygon) => {
                    miGeometria.coordinates.push(polygon);
                  });

                });

                this.searchData(selectedMunicipios, selectedProvincias, miGeometria);
              });

            } else {
              let cql_filter = '&cql_filter=provincia IN (';
              selectedProvincias.forEach((prov) => {
                cql_filter += "'" + prov + "',";
              });
              cql_filter = cql_filter.slice(0, -1);
              cql_filter += ')';
              M.remote.get(encodeURI(this.urlProvinciasGeom + cql_filter)).then((res) => {
                let result = JSON.parse(res.text);


                miGeometria = {
                  'type': 'MultiPolygon',
                  'coordinates': []
                }

                result.features.forEach((feature) => {

                  feature.geometry.coordinates.forEach((polygon) => {
                    miGeometria.coordinates.push(polygon);
                  });

                });

                this.searchData(selectedMunicipios, selectedProvincias, miGeometria);
              });
            }
          }, 1);
        }
      } else {
        M.dialog.info('<p>Atención:</p><p>Debe presionar el botón <b>Limpiar</b> para realizar una nueva búsqueda</p>');
      }

    });

    this.clearButton.addEventListener('click', () => {
      this.arrayFoundLayers = new Array();
      this.choices_selectMunicipios.removeActiveItems();
      this.choices_selectProvincias.removeActiveItems();
      this.choices_selectMunicipios.clearChoices();
      this.choices_selectMunicipios.setChoices(this.createSelectOptionsMunicipios());
      this.choices_selectProvincias.enable();
      this.choices_selectMunicipios.enable();
      this.divResultados.style.display = 'none';
      this.foundData.innerHTML = '';

      // eliminamos todos los features de la capa seleccion de elementos y de la capa de zona seleccionada
      if (this.SeleccionElementos_layer.getFeatures()[0]) {
        this.SeleccionElementos_layer.removeFeatures(this.SeleccionElementos_layer.getFeatures()[0]);
        this.SeleccionElementos_layer.clearStyle();
      }

      if (this.zoneSelected.getFeatures()[0]) {
        this.zoneSelected.removeFeatures(this.zoneSelected.getFeatures()[0]);
      }

      this.map_.setBbox(this.map_.getMaxExtent());

      // eliminamos los popup en el mapa

      if (this.map_.getPopup()) {
        this.map_.removePopup();
      }

      // eliminamos las capas GeoJSON creadas para realizar las búsquedas y que estaban ocultas

      this.map_.removeLayers(this.map_.getGeoJSON().filter(obj => obj.getImpl().name.includes('JSON')));



    });

    this.map_.on(M.evt.COMPLETED, () => {

      let buttonInfo = document.querySelectorAll('button#m-getfeatureinfo-button')[0] || document.querySelectorAll('div.m-panel.m-getfeatinf.opened.no-collapsible')[0];

      let maxExt = document.querySelectorAll('div.m-panel.m-maxextzoom.opened.no-collapsible')[0];

      if (!this.panel_.isCollapsed()) {
        maxExt.classList.add('ZoomGrouped');
        if (buttonInfo) {
          buttonInfo.classList.add('buttonInfoGrouped');
        }
      }
    });


    this.SeleccionElementos_layer.on(M.evt.SELECT_FEATURES, (feature) => {
      let originalLayer = feature[0].getId().split('.')[0];
      let originalLayerName = this.map_.getLayers({ name: originalLayer })[0].getImpl().legend;
      let previousPopup = this.map_.getPopup().getTabs().filter(obj => obj.title == 'Capa Seleccion de Elementos')[0];
      previousPopup.title = originalLayerName;
      this.map_.getPopup().update();
      this.beautifyPopup();

    });

    this.map_.on(M.evt.POPUP_ADDED, (popup) => {
      if (popup.getTabs()[0].icon == 'g-cartografia-pin') {
        // modificamos el titulo del popup para que coincida con el de la leyenda
        let initTitle = popup.getTabs()[0].title;
        if (initTitle != 'Capa Seleccion de Elementos') {
          let finalTitle = this.divMenus.querySelectorAll('div#ISELayer_' + initTitle)[0].querySelectorAll('p')[0].innerHTML;
          popup.element_.children[0].children[0].children[0].innerHTML = finalTitle;

        }

        this.beautifyPopup();
      }
      popup.on(M.evt.POPUP_ADDED_TAB, () => {

        setTimeout(() => {
          this.beautifyPopup();
        }, 1);


      });
    });

    this.map_.on(M.evt.POPUP_REMOVED, () => {
      // deseleccionamos los features seleccionados para que se puedan seleccionar de nuevo de manera inmediata
      this.map_.getFeatureHandler().clearSelectedFeatures();
    });
    //  MOVEMOS LOS PANELES SITUADOS EN BOTTOM RIGHT PARA QUE SEAN VISIBLES EN TODO MOMENTO

    this.panel_.on(M.evt.SHOW, () => {
      this.panelsBottomRight.forEach(panel => {
        panel.getTemplatePanel().classList.toggle('panelBottomRightOpened');
      });
      let buttonInfo = document.querySelectorAll('button#m-getfeatureinfo-button')[0] || document.querySelectorAll('div.m-panel.m-getfeatinf.opened.no-collapsible')[0];
      let maxExt = document.querySelectorAll('div.m-panel.m-maxextzoom.opened.no-collapsible')[0];

      buttonInfo.classList.add('buttonInfoGrouped');
      maxExt.classList.add('ZoomGrouped');
    });

    this.panel_.on(M.evt.HIDE, () => {
      this.panelsBottomRight.forEach(panel => {
        panel.getTemplatePanel().classList.toggle('panelBottomRightOpened');
      });
      let buttonInfo = document.querySelectorAll('button#m-getfeatureinfo-button')[0] || document.querySelectorAll('div.m-panel.m-getfeatinf.opened.no-collapsible')[0];
      let maxExt = document.querySelectorAll('div.m-panel.m-maxextzoom.opened.no-collapsible')[0];

      buttonInfo.classList.remove('buttonInfoGrouped');
      maxExt.classList.remove('ZoomGrouped');
    });

  }

  addEventsMenus() {

    //  FUNCIONALIDAD DESPLEGAR-OCULTAR LISTA CAPAS

    if (document.querySelectorAll('div.m-manageise')[0].querySelectorAll('div.GroupISE').length != 0) {
      this.grupos = document.querySelectorAll('div.m-manageise')[0].querySelectorAll('div.GroupISE');
    }

    if (document.querySelectorAll('div.m-manageise')[0].querySelectorAll('div.subGroupISE').length != 0) {
      this.subGrupos = document.querySelectorAll('div.m-manageise')[0].querySelectorAll('div.subGroupISE');
    }

    let recycleBin = document.querySelectorAll('div.divTitle button.g-cartografia-papelera');

    recycleBin.forEach((bin) => {
      bin.addEventListener('click', () => {
        let menuList = bin.parentNode.nextElementSibling;
        let selectedLayers = menuList.querySelectorAll('div.layerSelected');
        selectedLayers.forEach((layer) => {
          layer.children[0].click();
        });
      });
    });

    this.grupos.forEach(grupo => {
      grupo.addEventListener('click', (evt) => {
        if (evt.target.tagName == 'H3') {
          evt.target.classList.toggle('groupOpened');
          evt.target.classList.toggle('groupClosed');
          let itemsVisibles = document.querySelectorAll('.visible');
          if (itemsVisibles.length != 0) {
            if (!itemsVisibles[0].id.includes(grupo.id)) {
              itemsVisibles[0].parentNode.children[0].children[0].title = itemsVisibles[0].parentNode.children[0].children[0].title.replace('Oculta', 'Despliega');
              itemsVisibles[0].parentNode.children[0].children[0].classList.toggle('groupOpened');
              itemsVisibles[0].parentNode.children[0].children[0].classList.toggle('groupClosed');
              itemsVisibles[0].classList.toggle('visible');
              itemsVisibles[0].classList.toggle('oculta');
            }
          }
          let id = "layers_";
          id += grupo.id;
          document.querySelectorAll('div#' + id)[0].classList.toggle('oculta');
          document.querySelectorAll('div#' + id)[0].classList.toggle('visible');

          if (document.querySelectorAll('div#' + id)[0].classList.contains('visible')) {
            evt.target.title = 'Oculta las capas de ' + grupo.children[0].children[0].innerHTML;
          } else {
            evt.target.title = 'Despliega las capas de ' + grupo.children[0].children[0].innerHTML;
          }
        }

        //  SI HACEMOS CLICK SOBRE EL NOMBRE DE LA CAPA SE SELECCIONA O SE DESELECCIONA EN EL MAPA

        if (evt.target.tagName == 'P') {
          if (!evt.target.parentNode.classList.contains('layerSelected')) {
            evt.target.title = evt.target.title.replace('Añade', 'Elimina').replace('al mapa', 'del mapa');

            evt.target.parentNode.classList.add('layerSelected');

            if (evt.target.parentNode.classList.contains('ISELayer')) {
              evt.target.parentNode.parentNode.previousElementSibling.children[0].classList.add('elementMenuSelected');
              evt.target.parentNode.parentNode.previousElementSibling.children[1].classList.add('elementMenuSelected');
              this.layerToCharge = this.groupLayers.filter(obj => obj.groupName.replaceAll('á', 'a').replaceAll('é', 'e').replaceAll('í', 'i').replaceAll('ó', 'o').replaceAll('ú', 'u').replace(',', '_').replaceAll(' ', '_') == evt.target.parentNode.parentNode.parentNode.id)[0].layers.filter(obj => obj.name == evt.target.parentNode.id.replace('ISELayer_', ''))[0];
              this.addISELayers();
            } else {
              evt.target.parentNode.parentNode.previousElementSibling.classList.add('elementMenuSelected');
              evt.target.parentNode.parentNode.parentNode.parentNode.previousElementSibling.children[0].classList.add('elementMenuSelected');
              evt.target.parentNode.parentNode.parentNode.parentNode.previousElementSibling.children[1].classList.add('elementMenuSelected');

              this.layerToCharge = this.groupLayers.filter(obj => obj.groupName.replaceAll('á', 'a').replaceAll('é', 'e').replaceAll('í', 'i').replaceAll('ó', 'o').replaceAll('ú', 'u').replace(',', '_').replaceAll(' ', '_') == evt.target.parentNode.parentNode.parentNode.parentNode.parentNode.id)[0].layers.filter(obj => obj.name == evt.target.parentNode.id.replace('ISELayer_', ''))[0];
              this.addISELayers();
            }
          } else {
            if (evt.target.parentNode.classList.contains('ISELayer')) {
              evt.target.parentNode.parentNode.previousElementSibling.children[0].classList.remove('elementMenuSelected');
              evt.target.parentNode.parentNode.previousElementSibling.children[1].classList.remove('elementMenuSelected');
            } else {
              evt.target.parentNode.parentNode.previousElementSibling.classList.remove('elementMenuSelected');
              evt.target.parentNode.parentNode.parentNode.parentNode.previousElementSibling.children[0].classList.remove('elementMenuSelected');
              evt.target.parentNode.parentNode.parentNode.parentNode.previousElementSibling.children[1].classList.remove('elementMenuSelected');
            }
            evt.target.title = evt.target.title.replace('Elimina', 'Añade').replace('del mapa', 'al mapa');
            evt.target.parentNode.classList.remove('layerSelected');

            let layerToRemove;

            let nameLayer = evt.target.parentNode.id.replace('ISELayer_', '');

            this.groupLayers.forEach((group) => {
              if (group.layers.filter(obj => obj.name == nameLayer).length != 0) {
                layerToRemove = group.layers.filter(obj => obj.name == nameLayer)[0];
              }
            });

            this.removeISELayers(layerToRemove);


            // this.removeISELayers(evt.target.parentNode.id.replace('ISELayer_', ''));
            this.removeISELayerFromList(evt.target.parentNode.id.replace('ISELayer_', ''));
          }

        }
      });
    });

    this.subGrupos.forEach(subGrupo => {
      subGrupo.addEventListener('click', (evt) => {
        if (evt.target.tagName == 'H4') {
          evt.target.classList.toggle('subGroupOpened');
          evt.target.classList.toggle('subGroupClosed');
          let itemsVisibles = document.querySelectorAll('.subGroupVisible');
          if (itemsVisibles.length != 0) {
            if (!itemsVisibles[0].id.includes(subGrupo.id)) {
              itemsVisibles[0].parentNode.children[0].title = itemsVisibles[0].parentNode.children[0].title.replace('Oculta', 'Despliega');
              itemsVisibles[0].parentNode.children[0].classList.toggle('subGroupOpened');
              itemsVisibles[0].parentNode.children[0].classList.toggle('subGroupClosed');
              itemsVisibles[0].classList.toggle('subGroupVisible');
              itemsVisibles[0].classList.toggle('subGroupOculta');
            }
          }
          let id = "layers_";
          id += subGrupo.id;

          document.querySelectorAll('div#' + id)[0].classList.toggle('subGroupOculta');
          document.querySelectorAll('div#' + id)[0].classList.toggle('subGroupVisible');

          if (document.querySelectorAll('div#' + id)[0].classList.contains('subGroupVisible')) {
            evt.target.title = 'Oculta las capas de ' + subGrupo.children[0].innerHTML;
          } else {
            evt.target.title = 'Despliega las capas de ' + subGrupo.children[0].innerHTML;
          }
        }
      });

    });

  }

  addISELayers() {
    var layer = null;
    var lay = this.layerToCharge; // asignamos esta variable porque antes de que cargue la capa y se añada al menú de capas cargadas puede haber cambiado de valor
    if (lay.type == 'WFS') {
      layer = new M.layer.WFS({
        url: lay.url,
        namespace: lay.namespace,
        name: lay.name,
        legend: lay.legend,
        geometry: lay.geometry,
        extract: true
      }, {
        vendor: lay.vendor
      });

      if (lay.cql) {
        layer.getImpl().cql = lay.cql;
      }

      if (lay.style) {
        lay.style.forEach((st) => {
          layer.setStyle(st);
        });
      }
    }

    if (lay.type == 'WMS') {
      layer = new M.layer.WMS({
        name: lay.name,
        url: lay.url,
        legend: lay.legend,
        transparent: true,
        tiled: true
      });

      if (lay.style) {
        layer.getImpl().styles = lay.style;
      }
    }


    if (lay.type == 'GeoJSON') {
      layer = new M.layer.GeoJSON({
        name: lay.name,
        legend: lay.legend,
        url: encodeURI(lay.url),
      });

      lay.style.forEach((style) => {
        layer.setStyle(style);
      });

    }

    if (layer != null) {
      layer.setZIndex(this.zIndexToCharge);
      let orderSelected = this.zIndexToCharge;
      this.zIndexToCharge += 1;
      this.map_.addLayers(layer);

      layer.on(M.evt.LOAD, () => {
        if (document.querySelectorAll('div#ISELayer_' + lay.name)[0].classList.contains('layerSelected')) {
          this.addISELayerToList(lay, orderSelected);
        }
      });
    }
  }

  addISELayerToList(layer, orderSelected) {

    if (document.querySelectorAll('div#divListISELayers').length == 0) {
      this.divNoCapas.style.display = 'none';
      let contenedor = document.createElement('div');
      contenedor.id = 'divListISELayers';
      this.divCapasCargadas.appendChild(contenedor);
    }

    let legend;

    let name_layer = layer.name;

    let order = orderSelected * (-1);

    if (layer.type == 'WMS') {
      let url = layer.url.split('&CQL_FILTER=')[0];
      if (!layer.style) {
        legend = url + 'SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=' + layer.name + '&FORMAT=image/png&EXCEPTIONS=image/png';
      } else {
        legend = url + 'SERVICE=WMS&VERSION=1.3.0&REQUEST=GetLegendGraphic&LAYER=' + layer.name + '&STYLE=' + layer.style + '&FORMAT=image/png&EXCEPTIONS=image/png';
      }

      this.addElementLegend(layer, legend, order);
    } else {
      if (typeof this.map_.getLayers({ name: name_layer })[0].getStyle().toImage() === 'string') {
        legend = this.map_.getLayers({ name: name_layer })[0].getStyle().toImage();
        this.addElementLegend(layer, legend, order);
      } else {
        this.map_.getLayers({ name: name_layer })[0].getLegendURL().then((res) => {
          legend = res;
          this.addElementLegend(layer, legend, order);
        });
      }
    }

  }

  addElementLegend(layer, legend, order) {
    let dV = document.createElement('div');
    let textoToc;

    let nombreConsejeria = false;

    let originalGroup = this.groupLayers.filter(obj => obj.groupName == 'Sedes')[0].layers.filter(obj => obj.name == layer.name);
    if (originalGroup.length != 0) {
      if (originalGroup[0].group_2) {
        nombreConsejeria = originalGroup[0].group_2;
      }
    }

    if (layer.legend.length > 26) {
      textoToc = layer.legend.slice(0, 26) + ' ...';
    } else {
      textoToc = layer.legend;
    }
    dV.className = 'listISELayer';
    dV.id = 'legend_' + layer.name;

    let chain = '';

    if (nombreConsejeria) {
      chain += '<div class="nombreConsejeria">' + nombreConsejeria + '</div>\n';
    }

    chain += '<div class="listISELayerControls">\n<button class="visibilityLegend g-cartografia-flecha-arriba2" title="oculta la leyenda"></button>\n<button class="visibilityLayer g-cartografia-check3" title="oculta la capa"></button>\n<p title="arrastra para ordenar la capa en el TOC">' + textoToc + '</p>\n<input type="range" data-layer-name="' + layer.name + '" class="m-manageise-transparency" min="0" max="1" step="0.1" value="1" title="control de transparencia">\n<button class="removeLayer g-cartografia-cancelar" title="elimina la capa"></button>\n</div>\n<div class="listISELayerLegend">\n<img data-layer-name="' + layer.name + '" src="' + legend + '">\n</div>';

    // if (nombreConsejeria) {
    //   chain += '<br><p>' + nombreConsejeria + '</p>\n';
    // }

    // chain += '</div>\n<div class="listISELayerLegend">\n<img data-layer-name="' + layer.name + '" src="' + legend + '">\n</div>';

    dV.innerHTML = chain;
    // dV.innerHTML = '<div class="listISELayerControls">\n<button class="visibilityLegend g-cartografia-flecha-arriba2" title="oculta la leyenda"></button>\n<button class="visibilityLayer g-cartografia-check3" title="oculta la capa"></button>\n<p title="arrastra para ordenar la capa en el TOC">' + textoToc + '</p>\n<input type="range" data-layer-name="' + layer.name + '" class="m-manageise-transparency" min="0" max="1" step="0.1" value="1" title="control de transparencia">\n<button class="removeLayer g-cartografia-cancelar" title="elimina la capa"></button>\n</div>\n<div class="listISELayerLegend">\n<img data-layer-name="' + layer.name + '" src="' + legend + '">\n</div>';





    this.divCapasCargadas.children['divListISELayers'].appendChild(dV);

    document.getElementById('legend_' + layer.name).style.order = order;
    this.addFunctionLayerList(layer);
  }

  addFunctionLayerList(layer) {
    let name = layer.name;
    let titulo = document.querySelectorAll('div#legend_' + name + ' p')[0];
    let nombreConsejeria = document.querySelectorAll('div#legend_' + name + ' div.nombreConsejeria')[0];
    let buttonRemoveLayer = document.querySelectorAll('div#legend_' + name + ' button.removeLayer')[0];
    let buttonVisibilityLayer = document.querySelectorAll('div#legend_' + name + ' button.visibilityLayer')[0];
    let opacityRange = document.querySelectorAll('div#legend_' + name + ' input[type="range"]')[0];
    let buttonVisibilityLegend = document.querySelectorAll('div#legend_' + name + ' button.visibilityLegend')[0];


    if (nombreConsejeria !== undefined) {
      nombreConsejeria.addEventListener('mousedown', (evt) => {
        let divToMove = evt.target.parentNode;
        let elementMouseOver = false;
        let shiftY = evt.clientY - divToMove.getBoundingClientRect().top;
        let topeSup = document.getElementById('divListISELayers').getBoundingClientRect().top;
        let divCapas = document.getElementById('divListISELayers').children;

        let dimDivCapas = [];

        let transparencyDivToMove = divToMove.querySelectorAll('input.m-manageise-transparency')[0].value;

        if (document.querySelectorAll('div.listISELayer').length > 1) {
          divToMove.style.position = 'absolute';
          divToMove.style.zIndex = 10000;
          divToMove.style.opacity = 0.5;

          for (let div of divCapas) {
            if (div.id != divToMove.id) {
              let visibility;
              if (div.querySelectorAll('button.g-cartografia-flecha-arriba2').length == 0) {
                visibility = false;
              } else {
                visibility = true;
              }
              let elem = {
                id: div.id,
                order: div.style.order,
                top: null,
                bottom: null,
                visibility: visibility
              }
              dimDivCapas.push(elem);
            }
          }

          for (let div of divCapas) {
            if (div.id != divToMove.id) {
              if (div.querySelectorAll('button.g-cartografia-flecha-arriba2').length != 0) {
                div.querySelectorAll('button.g-cartografia-flecha-arriba2')[0].click();
              }
            }
          }

          dimDivCapas.sort((a, b) => {
            if (parseInt(a.order) > parseInt(b.order)) {
              return 1;
            }
            if (parseInt(a.order) < parseInt(b.order)) {
              return -1;
            }
            return 0;
          });

          let htmlElement1;
          let htmlElement2;

          if (dimDivCapas.length > 1) {
            for (let i = 0; i < dimDivCapas.length; i++) {

              if (i == 0) {
                htmlElement1 = document.getElementById(dimDivCapas[i].id);
                htmlElement2 = document.getElementById(dimDivCapas[i + 1].id);
                dimDivCapas[i].top = htmlElement1.getBoundingClientRect().top;
                dimDivCapas[i].bottom = Math.trunc(((htmlElement1.getBoundingClientRect().top - 10) + (htmlElement2.getBoundingClientRect().top - 10)) / 2);
              } else {
                if (i == dimDivCapas.length - 1) {
                  htmlElement1 = document.getElementById(dimDivCapas[i].id);
                  dimDivCapas[i].top = dimDivCapas[i - 1].bottom;
                  dimDivCapas[i].bottom = htmlElement1.getBoundingClientRect().bottom;
                } else {
                  htmlElement1 = document.getElementById(dimDivCapas[i].id);
                  htmlElement2 = document.getElementById(dimDivCapas[i + 1].id);
                  dimDivCapas[i].top = dimDivCapas[i - 1].bottom;
                  dimDivCapas[i].bottom = Math.trunc(((htmlElement1.getBoundingClientRect().top - 10) + (htmlElement2.getBoundingClientRect().top - 10)) / 2);
                }
              }
            }
          } else {
            htmlElement1 = document.getElementById(dimDivCapas[0].id);
            dimDivCapas[0].top = htmlElement1.getBoundingClientRect().top;
            dimDivCapas[0].bottom = Math.trunc(htmlElement1.getBoundingClientRect().top + ((htmlElement1.getBoundingClientRect().height) / 2));
          }
        }

        function moveAt(pageY) {
          if (document.querySelectorAll('div.listISELayer').length > 1) {
            let idElementMouseOver;
            if (pageY > topeSup) {
              if (dimDivCapas.filter(obj => obj.top <= pageY && obj.bottom > pageY).length != 0) {
                idElementMouseOver = dimDivCapas.filter(obj => obj.top <= pageY && obj.bottom > pageY)[0].id;
              } else {
                if (pageY < dimDivCapas[0].top) {
                  idElementMouseOver = dimDivCapas[0].id;
                } else {
                  idElementMouseOver = dimDivCapas[dimDivCapas.length - 1].id;
                }
              }

              divToMove.style.top = pageY - shiftY + 'px';


              if (!elementMouseOver) {
                elementMouseOver = document.getElementById(idElementMouseOver);
                if (pageY < dimDivCapas[dimDivCapas.length - 1].bottom) {
                  elementMouseOver.style.marginTop = '50px';
                }
              } else {
                if (pageY < dimDivCapas[dimDivCapas.length - 1].bottom && elementMouseOver.id == idElementMouseOver) {
                  elementMouseOver = document.getElementById(idElementMouseOver);
                  elementMouseOver.style.marginTop = '50px';
                }
                if (elementMouseOver.id != idElementMouseOver) {
                  elementMouseOver.style.removeProperty('margin-top');

                  elementMouseOver = document.getElementById(idElementMouseOver);
                  elementMouseOver.style.marginTop = '50px';
                }
                if (pageY > dimDivCapas[dimDivCapas.length - 1].bottom) {
                  elementMouseOver.style.removeProperty('margin-top');
                }

              }
            }
          }
        }


        function onMouseMove(evt) {
          moveAt(evt.pageY);
        }

        if (document.querySelectorAll('div.listISELayer').length > 1) {

          divToMove.style.left = '20px';

          moveAt(evt.pageY);
          document.addEventListener('mousemove', onMouseMove);


          divToMove.addEventListener('mouseup', (evt) => {
            let divTarget = dimDivCapas.filter(obj => obj.top <= evt.pageY && obj.bottom > evt.pageY);

            let indexDivToMove = parseInt(document.getElementById(divToMove.id).style.order);



            let index;

            if (divTarget.length == 0) {
              if (evt.pageY > dimDivCapas[dimDivCapas.length - 1].bottom) {
                divTarget = [dimDivCapas[dimDivCapas.length - 1]];
              } else {
                divTarget = [dimDivCapas[0]];
              }
            }

            if (indexDivToMove < parseInt(divTarget[0].order)) {
              if (elementMouseOver.style.marginTop) {
                index = parseInt(divTarget[0].order) - 1;
              } else {
                index = parseInt(divTarget[0].order);
              }
            } else {
              if (dimDivCapas[dimDivCapas.length - 1].bottom < evt.pageY) {
                index = parseInt(divTarget[0].order) + 1;
              } else {
                index = parseInt(divTarget[0].order);
              }
            }

            elementMouseOver.style.removeProperty('margin-top');

            document.removeEventListener('mousemove', onMouseMove);

            divToMove = document.getElementById(divToMove.id);
            divToMove.style.removeProperty('position');
            divToMove.style.removeProperty('z-index');
            divToMove.style.removeProperty('top');
            divToMove.style.removeProperty('left');
            divToMove.style.removeProperty('opacity');

            this.ordenaCapasToc(divToMove, index);

            let classDiv = divToMove.className;
            let idDiv = divToMove.id;
            let orderDiv = divToMove.style.order;
            let contentDiv = divToMove.innerHTML;

            //  eliminamos el div movido para eliminar así también el evento mouseup asociado a él

            document.getElementById('divListISELayers').removeChild(document.getElementById(idDiv));

            //  lo volvemos a crear y lo insertamos en divListDeraLayers

            let newDiv = document.createElement('div');
            newDiv.className = classDiv;
            newDiv.id = idDiv;
            newDiv.style.order = orderDiv;

            newDiv.innerHTML = contentDiv;


            newDiv.querySelectorAll('input.m-manageise-transparency')[0].value = transparencyDivToMove;
            document.getElementById('divListISELayers').appendChild(newDiv);


            let layerToAddFunctions;
            this.groupLayers.forEach((group) => {
              if (group.layers.filter(obj => obj.name == idDiv.replace('legend_', '')).length != 0) {
                layerToAddFunctions = group.layers.filter(obj => obj.name == idDiv.replace('legend_', ''))[0];
              }
            });

            //  volvemos a añadir los eventos al div movido anteriormente

            this.addFunctionLayerList(layerToAddFunctions);

            //  si las leyendas estaban desplegadas antes de mover el div las volvemos a desplegar

            for (let elem of dimDivCapas) {
              if (elem.visibility) {
                if (document.querySelectorAll('div#' + elem.id + ' button.g-cartografia-flecha-abajo2').length != 0) {
                  document.querySelectorAll('div#' + elem.id + ' button.g-cartografia-flecha-abajo2')[0].click();
                }
              }
            }
          });
        }
      });
    }


    titulo.addEventListener('mousedown', (evt) => {

      let divToMove = evt.target.parentNode.parentNode;
      let elementMouseOver = false;
      let shiftY = evt.clientY - divToMove.getBoundingClientRect().top;
      let topeSup = document.getElementById('divListISELayers').getBoundingClientRect().top;
      let divCapas = document.getElementById('divListISELayers').children;

      let dimDivCapas = [];

      let transparencyDivToMove = divToMove.querySelectorAll('input.m-manageise-transparency')[0].value;

      if (document.querySelectorAll('div.listISELayer').length > 1) {
        divToMove.style.position = 'absolute';
        divToMove.style.zIndex = 10000;
        divToMove.style.opacity = 0.5;

        for (let div of divCapas) {
          if (div.id != divToMove.id) {
            let visibility;
            if (div.querySelectorAll('button.g-cartografia-flecha-arriba2').length == 0) {
              visibility = false;
            } else {
              visibility = true;
            }
            let elem = {
              id: div.id,
              order: div.style.order,
              top: null,
              bottom: null,
              visibility: visibility
            }
            dimDivCapas.push(elem);
          }
        }

        for (let div of divCapas) {
          if (div.id != divToMove.id) {
            if (div.querySelectorAll('button.g-cartografia-flecha-arriba2').length != 0) {
              div.querySelectorAll('button.g-cartografia-flecha-arriba2')[0].click();
            }
          }
        }

        dimDivCapas.sort((a, b) => {
          if (parseInt(a.order) > parseInt(b.order)) {
            return 1;
          }
          if (parseInt(a.order) < parseInt(b.order)) {
            return -1;
          }
          return 0;
        });

        let htmlElement1;
        let htmlElement2;

        if (dimDivCapas.length > 1) {
          for (let i = 0; i < dimDivCapas.length; i++) {

            if (i == 0) {
              htmlElement1 = document.getElementById(dimDivCapas[i].id);
              htmlElement2 = document.getElementById(dimDivCapas[i + 1].id);
              dimDivCapas[i].top = htmlElement1.getBoundingClientRect().top;
              dimDivCapas[i].bottom = Math.trunc(((htmlElement1.getBoundingClientRect().top - 10) + (htmlElement2.getBoundingClientRect().top - 10)) / 2);
            } else {
              if (i == dimDivCapas.length - 1) {
                htmlElement1 = document.getElementById(dimDivCapas[i].id);
                dimDivCapas[i].top = dimDivCapas[i - 1].bottom;
                dimDivCapas[i].bottom = htmlElement1.getBoundingClientRect().bottom;
              } else {
                htmlElement1 = document.getElementById(dimDivCapas[i].id);
                htmlElement2 = document.getElementById(dimDivCapas[i + 1].id);
                dimDivCapas[i].top = dimDivCapas[i - 1].bottom;
                dimDivCapas[i].bottom = Math.trunc(((htmlElement1.getBoundingClientRect().top - 10) + (htmlElement2.getBoundingClientRect().top - 10)) / 2);
              }
            }
          }
        } else {
          htmlElement1 = document.getElementById(dimDivCapas[0].id);
          dimDivCapas[0].top = htmlElement1.getBoundingClientRect().top;
          dimDivCapas[0].bottom = Math.trunc(htmlElement1.getBoundingClientRect().top + ((htmlElement1.getBoundingClientRect().height) / 2));
        }
      }

      function moveAt(pageY) {
        if (document.querySelectorAll('div.listISELayer').length > 1) {
          let idElementMouseOver;
          if (pageY > topeSup) {
            if (dimDivCapas.filter(obj => obj.top <= pageY && obj.bottom > pageY).length != 0) {
              idElementMouseOver = dimDivCapas.filter(obj => obj.top <= pageY && obj.bottom > pageY)[0].id;
            } else {
              if (pageY < dimDivCapas[0].top) {
                idElementMouseOver = dimDivCapas[0].id;
              } else {
                idElementMouseOver = dimDivCapas[dimDivCapas.length - 1].id;
              }
            }

            divToMove.style.top = pageY - shiftY + 'px';


            if (!elementMouseOver) {
              elementMouseOver = document.getElementById(idElementMouseOver);
              if (pageY < dimDivCapas[dimDivCapas.length - 1].bottom) {
                elementMouseOver.style.marginTop = '50px';
              }
            } else {
              if (pageY < dimDivCapas[dimDivCapas.length - 1].bottom && elementMouseOver.id == idElementMouseOver) {
                elementMouseOver = document.getElementById(idElementMouseOver);
                elementMouseOver.style.marginTop = '50px';
              }
              if (elementMouseOver.id != idElementMouseOver) {
                elementMouseOver.style.removeProperty('margin-top');

                elementMouseOver = document.getElementById(idElementMouseOver);
                elementMouseOver.style.marginTop = '50px';
              }
              if (pageY > dimDivCapas[dimDivCapas.length - 1].bottom) {
                elementMouseOver.style.removeProperty('margin-top');
              }

            }
          }
        }
      }


      function onMouseMove(evt) {
        moveAt(evt.pageY);
      }

      if (document.querySelectorAll('div.listISELayer').length > 1) {

        divToMove.style.left = '20px';

        moveAt(evt.pageY);
        document.addEventListener('mousemove', onMouseMove);


        divToMove.addEventListener('mouseup', (evt) => {
          let divTarget = dimDivCapas.filter(obj => obj.top <= evt.pageY && obj.bottom > evt.pageY);

          let indexDivToMove = parseInt(document.getElementById(divToMove.id).style.order);



          let index;

          if (divTarget.length == 0) {
            if (evt.pageY > dimDivCapas[dimDivCapas.length - 1].bottom) {
              divTarget = [dimDivCapas[dimDivCapas.length - 1]];
            } else {
              divTarget = [dimDivCapas[0]];
            }
          }

          if (indexDivToMove < parseInt(divTarget[0].order)) {
            if (elementMouseOver.style.marginTop) {
              index = parseInt(divTarget[0].order) - 1;
            } else {
              index = parseInt(divTarget[0].order);
            }
          } else {
            if (dimDivCapas[dimDivCapas.length - 1].bottom < evt.pageY) {
              index = parseInt(divTarget[0].order) + 1;
            } else {
              index = parseInt(divTarget[0].order);
            }
          }

          elementMouseOver.style.removeProperty('margin-top');

          document.removeEventListener('mousemove', onMouseMove);

          divToMove = document.getElementById(divToMove.id);
          divToMove.style.removeProperty('position');
          divToMove.style.removeProperty('z-index');
          divToMove.style.removeProperty('top');
          divToMove.style.removeProperty('left');
          divToMove.style.removeProperty('opacity');

          this.ordenaCapasToc(divToMove, index);

          let classDiv = divToMove.className;
          let idDiv = divToMove.id;
          let orderDiv = divToMove.style.order;
          let contentDiv = divToMove.innerHTML;

          //  eliminamos el div movido para eliminar así también el evento mouseup asociado a él

          document.getElementById('divListISELayers').removeChild(document.getElementById(idDiv));

          //  lo volvemos a crear y lo insertamos en divListDeraLayers

          let newDiv = document.createElement('div');
          newDiv.className = classDiv;
          newDiv.id = idDiv;
          newDiv.style.order = orderDiv;

          newDiv.innerHTML = contentDiv;


          newDiv.querySelectorAll('input.m-manageise-transparency')[0].value = transparencyDivToMove;
          document.getElementById('divListISELayers').appendChild(newDiv);


          let layerToAddFunctions;
          this.groupLayers.forEach((group) => {
            if (group.layers.filter(obj => obj.name == idDiv.replace('legend_', '')).length != 0) {
              layerToAddFunctions = group.layers.filter(obj => obj.name == idDiv.replace('legend_', ''))[0];
            }
          });

          //  volvemos a añadir los eventos al div movido anteriormente

          this.addFunctionLayerList(layerToAddFunctions);

          //  si las leyendas estaban desplegadas antes de mover el div las volvemos a desplegar

          for (let elem of dimDivCapas) {
            if (elem.visibility) {
              if (document.querySelectorAll('div#' + elem.id + ' button.g-cartografia-flecha-abajo2').length != 0) {
                document.querySelectorAll('div#' + elem.id + ' button.g-cartografia-flecha-abajo2')[0].click();
              }
            }
          }
        });
      }

    });


    buttonVisibilityLayer.addEventListener('click', () => {
      if (buttonVisibilityLayer.classList.contains('g-cartografia-check3')) {
        this.map_.getLayers({ name: layer.name })[0].setVisible(false);
        buttonVisibilityLayer.title = 'hace visible la capa';
      } else {
        this.map_.getLayers({ name: layer.name })[0].setVisible(true);
        buttonVisibilityLayer.title = 'oculta la capa';
      }
      buttonVisibilityLayer.classList.toggle('g-cartografia-check3');
      buttonVisibilityLayer.classList.toggle('g-cartografia-check2');

    });

    buttonRemoveLayer.addEventListener('click', () => {
      this.map_.removeLayers({ name: layer.name });
      if (document.getElementById('ISELayer_' + layer.name) == null) {
        document.getElementById('ISELayer_' + layer.style).querySelectorAll('p')[0].click();
      } else {
        document.getElementById('ISELayer_' + layer.name).querySelectorAll('p')[0].click();
      }

      let elementsDivISELayer = Array.from(document.querySelectorAll('div.listISELayer'));

      // ordenamos los elementos del divSIEHAndLayers según su order
      elementsDivISELayer.sort((a, b) => {
        if (parseInt(a.style.order) < parseInt(b.style.order)) {
          return 1;
        }
        if (parseInt(a.style.order) > parseInt(b.style.order)) {
          return -1;
        }
        return 0;
      });

      // reasignamos los zIndex de las capas SIEHAnd y modificamos su order en divListSIEHAndLayers

      for (let i = 0; i < elementsDivISELayer.length; i++) {
        let nameLayer = elementsDivISELayer[i].id.replace('legend_', '');
        this.map_.getLayers({ name: nameLayer })[0].setZIndex(2000 + i);
        document.querySelectorAll('div#legend_' + nameLayer)[0].style.order = (2000 + i) * (-1);
      }

      this.zIndexToCharge = elementsDivISELayer.length + 2000;

    });


    opacityRange.addEventListener('change', () => {
      this.map_.getLayers({ name: layer.name })[0].setOpacity(parseFloat(opacityRange.value));
    });

    buttonVisibilityLegend.addEventListener('click', () => {
      if (buttonVisibilityLegend.classList.contains('g-cartografia-flecha-arriba2')) {
        document.querySelectorAll('div#legend_' + layer.name + '>div.listISELayerLegend')[0].style.display = 'none';
        buttonVisibilityLegend.title = 'muestra la leyenda';
      } else {
        document.querySelectorAll('div#legend_' + layer.name + '>div.listISELayerLegend')[0].style.display = 'block';
        buttonVisibilityLegend.title = 'oculta la leyenda';
      }
      buttonVisibilityLegend.classList.toggle('g-cartografia-flecha-arriba2');
      buttonVisibilityLegend.classList.toggle('g-cartografia-flecha-abajo2');
    });

  }

  ordenaCapasMap(children) {
    for (let child of children) {
      let nameLayer = child.id.replace('legend_', '');
      let index = parseInt(child.style.order) * (-1);
      this.map_.getLayers({ name: nameLayer })[0].setZIndex(index);
    }
  }

  ordenaCapasToc(divToMove, index) {
    let children = document.getElementById('divListISELayers').children;
    let movedOrder = parseInt(divToMove.style.order);

    let indexSelected = index;

    if (movedOrder != indexSelected) {
      for (let child of children) {
        let currentOrder = parseInt(child.style.order);
        if (movedOrder > indexSelected) {
          if (child.id != divToMove.id) {
            if (currentOrder < movedOrder && currentOrder >= indexSelected) {
              child.style.order = currentOrder + 1;
            }
          } else {
            divToMove.style.order = indexSelected;
          }
        } else {
          if (child.id != divToMove.id) {
            if (currentOrder > movedOrder && currentOrder <= indexSelected) {
              child.style.order = currentOrder - 1;
            }
          } else {
            if (indexSelected > -2000) {
              divToMove.style.order = indexSelected - 1;
            } else {
              divToMove.style.order = indexSelected;
            }

          }
        }
      }

      this.ordenaCapasMap(children);

    }

  }

  removeISELayers(layer) {

    let layerToRemove = this.map_.getLayers({ name: layer.name });

    if (layer.type != 'GeoJSON') {
      layerToRemove = layerToRemove.filter(obj => obj.impl_.legend == layer.legend);
    } else {
      layerToRemove = layerToRemove.filter(obj => obj.impl_.name == layer.name);
    }

    this.map_.removeLayers(layerToRemove);

    // this.map_.removeLayers(this.map_.getLayers({ name: nameLayer }));

    if (this.map_.getPopup() != null) {
      this.map_.removePopup(this.map_.getPopup());
    }
  }

  removeISELayerFromList(layer) {
    if (document.getElementById('legend_' + layer) != null) {
      document.getElementById('legend_' + layer).remove();
    }
    //  si no hay capas ISE cargadas eliminamos el titulo capas ISE
    if (document.querySelectorAll('div.listISELayer').length == 0) {
      document.getElementById('divListISELayers').remove();
      this.divNoCapas.style.display = 'block';
    }
  }

  beautifyPopup() {

    let title = document.querySelectorAll('div.m-geojson-content')[0].parentNode.parentNode.querySelectorAll('div.m-title')[0];

    if (title !== undefined) {

      if (this.map_.getPopup().getTabs().filter(obj => obj.icon == 'g-cartografia-pin').length != 0) {
        title.classList.add('titleISE');
      }
    } else {

      let addedTitle = document.createElement("div");

      if (this.map_.getLayers({ name: this.map_.getPopup().getTabs()[0].title }).length != 0) {
        let layName = this.map_.getLayers({ name: this.map_.getPopup().getTabs()[0].title })[0].getImpl().name;
        this.groupLayers.forEach((group) => {
          if (group.layers.filter(obj => obj.name == layName).length != 0) {
            addedTitle.innerHTML = group.layers.filter(obj => obj.name == layName)[0].legend;
          }
        });
        // addedTitle.innerHTML = this.map_.getLayers({ name: this.map_.getPopup().getTabs()[0].title })[0].getImpl().legend;
      } else {

        addedTitle.innerHTML = this.map_.getPopup().getTabs()[0].title;
      }

      addedTitle.classList.add('m-title', 'titleISE');

      let tabs = document.querySelectorAll('div.m-tabs')[0].children;
      let nodeOrigin = document.querySelectorAll('div.m-geojson-content')[0].parentNode.parentNode.querySelectorAll('div.m-header')[0];
      let closePopup = nodeOrigin.querySelectorAll('a.m-popup-closer')[0];
      nodeOrigin.insertBefore(addedTitle, closePopup);

      for (let tab of tabs) {
        tab.addEventListener('click', () => {
          let typeTab = tab.children[0].className;
          let titlePopup = document.querySelectorAll('div.m-popup')[0].querySelectorAll('div.m-title')[0];
          let index = tab.dataset['index'];
          let initTitle = this.map_.getPopup().getTabs()[index].title;
          let endTitle;
          if (initTitle === undefined) {
            endTitle = this.map_.getLayers({ name: initTitle })[0].getImpl().legend;
          } else {
            if (this.map_.getLayers({ name: initTitle }).length != 0) {

              this.groupLayers.forEach((group) => {
                if (group.layers.filter(obj => obj.name == initTitle).length != 0) {
                  addedTitle.innerHTML = group.layers.filter(obj => obj.name == initTitle)[0].legend;
                  endTitle = group.layers.filter(obj => obj.name == initTitle)[0].legend;
                }
              });
            } else {
              endTitle = initTitle;
            }
          }

          titlePopup.innerHTML = endTitle;
          if (typeTab == 'g-cartografia-info') {
            if (titlePopup.classList.contains('titleISE')) {
              titlePopup.classList.remove('titleISE');
            }
          }
          if (typeTab == 'g-cartografia-pin') {
            if (!titlePopup.classList.contains('titleISE')) {
              titlePopup.classList.add('titleISE');
            }
          }


          let fieldFoto = Array.from(document.querySelectorAll('div.m-geojson-content')[0].querySelectorAll('td.key')).filter(obj => obj.innerHTML == 'Foto');

          if (fieldFoto.length != 0) {
            let urlFoto = fieldFoto[0].nextElementSibling.innerHTML;
            if (urlFoto != 'No disponible') {
              if(!urlFoto.includes('<img src="')){
                let newChain = '<img src="' + urlFoto + '">';
                // console.log(urlFoto);
                fieldFoto[0].nextElementSibling.innerHTML = newChain;
              } 
            } else {
              fieldFoto[0].parentNode.parentNode.parentNode.style.display = 'none';
            }
          }





        });
      }
    }


    let fieldFoto = Array.from(document.querySelectorAll('div.m-geojson-content')[0].querySelectorAll('td.key')).filter(obj => obj.innerHTML == 'Foto');
    console.log(fieldFoto);
    if (fieldFoto.length != 0) {
      let urlFoto = fieldFoto[0].nextElementSibling.innerHTML;
      console.log(urlFoto);
      if (urlFoto != 'No disponible') {
        if(!urlFoto.includes('<img src="')){
          let newChain = '<img src="' + urlFoto + '">';
          // console.log(urlFoto);
          fieldFoto[0].nextElementSibling.innerHTML = newChain;
        }        
      } else {
        fieldFoto[0].parentNode.parentNode.parentNode.style.display = 'none';
      }
    }



  }

  searchData(listMuni, listProv, spatialFilter) {
    let numberOfSearch = this.arrayFoundLayers.length;

    let featureZonaSelected = new M.Feature("zonaSeleccionada", {
      "type": "Feature",
      "id": "zonaSeleccionada.1",
      "geometry": spatialFilter,
      "geometry_name": "geometry",
      "properties": {}
    });

    if (this.zoneSelected.getFeatures()[0]) {
      this.zoneSelected.removeFeatures(this.zoneSelected.getFeatures()[0]);
    }

    this.zoneSelected.addFeatures(featureZonaSelected);

    this.map_.setBbox(this.zoneSelected.getMaxExtent());



    let foundFeatures = new Array();
    this.arrayFoundLayers.forEach((layer) => {
      let featuresByLayer = {
        layer: layer.name,
        layerLegend: layer.legend,
        type: layer.type,
        features: []
      }

      if ((layer.type == 'WFS') || (layer.type == 'GeoJSON')) {
        if (listMuni.length != 0) {
          listMuni.forEach((muni) => {
            let feats = this.map_.getLayers({ name: layer.name })[0].getFeatures().filter(obj => obj.impl_.olFeature_.values_[layer.searchFields[0]] == muni);
            feats.forEach((feat) => {
              let values = feat.getAttributes();
              values.idJSON = feat.getImpl().getOLFeature().getId();
              featuresByLayer.features.push(values);
            });
          });

          if (featuresByLayer.features.length != 0) {
            foundFeatures.push(featuresByLayer);
          }
        } else {
          listProv.forEach((prov) => {
            let feats = this.map_.getLayers({ name: layer.name })[0].getFeatures().filter(obj => obj.impl_.olFeature_.values_[layer.searchFields[1]] == prov);
            feats.forEach((feat) => {
              let values = feat.getAttributes();
              values.idJSON = feat.getImpl().getOLFeature().getId();
              featuresByLayer.features.push(values);
            });
          });
          if (featuresByLayer.features.length != 0) {
            foundFeatures.push(featuresByLayer);
          }

        }
        numberOfSearch -= 1;
        if (numberOfSearch == 0) {
          this.showResults(foundFeatures);
        }
      }


      if (layer.type == 'WMS') {
        let query = layer.url.replace('/wms?', '/wfs?') + 'service=WFS&version=1.1.0&request=GetFeature&typename=' + layer.name + '&srsname=EPSG:25830&outputFormat=json';

        M.remote.get(encodeURI(query)).then((res) => {
          let result = JSON.parse(res.text);

          let zoneSearch = new M.layer.GeoJSON({
            source: result,
            name: layer.name + 'JSON',
            extract: false
          });

          zoneSearch.setStyle(this.hiddenStyle);

          this.map_.addLayers(zoneSearch);
          zoneSearch.on(M.evt.LOAD, () => {
            let filter = M.filter.spatial.INTERSECT(spatialFilter);
            zoneSearch.setFilter(filter);
            let features = zoneSearch.getFeatures();
            features.forEach((feature) => {
              let values = feature.getImpl().getAttributes();
              values.idJSON = feature.getImpl().getOLFeature().getId();
              featuresByLayer.features.push(values);
            });

            if (featuresByLayer.features.length != 0) {
              foundFeatures.push(featuresByLayer);
            }

            numberOfSearch -= 1;
            if (numberOfSearch == 0) {
              this.showResults(foundFeatures);
            }
          });

        });

      }



    });

  }

  showResults(foundFeatures) {
    this.divResultados.style.display = 'block';

    if (foundFeatures.length != 0) {
      foundFeatures.forEach((layer) => {
        let totalCadena = '';
        let nombreLegend = layer.layerLegend;
        let nombreAlt = layer.layerLegend;
        let originalGroup = this.groupLayers.filter(obj => obj.groupName == 'Sedes')[0].layers.filter(obj => obj.name == layer.layer);
        if (originalGroup.length != 0) {
          if (originalGroup[0].group_2) {
            nombreLegend += ' - ' + originalGroup[0].group_2.replace('Consejería de ', '');
            nombreAlt += ' - ' + originalGroup[0].group_2;
          }
        }



        if (nombreLegend.length > 55) {
          nombreLegend = nombreLegend.slice(0, 55) + '...';
        }

        this.foundData.innerHTML += '<div class="layerName"><h4 id="title_' + layer.layer + '" class="titulo_resultado hidden">&#9658; ' + nombreLegend + ' (' + layer.features.length + ' resultados)</h4><button class="downLoadCSV m-tool-button g-cartografia-descargar" data-download="' + layer.layer + '" alt="Descargar ' + nombreAlt + ' en formato CSV" title="Descargar ' + nombreAlt + ' (Formato CSV)"></button></div>\n';

        layer.features.forEach((feature) => {
          let cadena;
          if (layer.type == 'GeoJSON') {
            cadena = '<table id="tab_' + layer.layer + '.' + feature.idJSON.split('.')[1] + '" class="hidden" data-feature-id="' + feature.idJSON + '">\n<tbody>\n';
          } else {
            cadena = '<table id="tab_' + feature.idJSON + '" class="hidden" data-feature-id="' + feature.idJSON + '">\n<tbody>\n';
          }

          Object.entries(feature).forEach(([key, value]) => {
            if (key != 'idJSON') {
              if ((key == 'foto') && (value != 'No disponible')) {
                cadena += '<tr>\n<th>' + key + '</th>\n<td>\n<img src="' + value + '">\n</td>\n</tr>\n';
              } else {
                cadena += '<tr>\n<th>' + key + '</th>\n<td>' + value + '</td>\n</tr>\n';
              }

            }
          });
          cadena += '</tbody>\n</table>\n';
          totalCadena += cadena;
        });
        this.foundData.innerHTML += totalCadena;
      });

      document.querySelectorAll('.titulo_resultado').forEach(el => {
        el.addEventListener('click', e => {
          // si hay menus abiertos los cerramos antes de abrir otro
          if (document.querySelectorAll('h4.shown')[0] && document.querySelectorAll('h4.shown')[0].id != e.target.id) {
            document.querySelectorAll('h4.shown')[0].click();
          }

          let nameLayer = e.target.id.replace('title_', '');

          let tables = document.querySelectorAll('table[id^="tab_' + nameLayer + '."]');

          for (let table of tables) {
            table.classList.toggle('hidden');
            table.classList.toggle('shown');
          }
          if (e.target.classList.contains('hidden')) {
            e.target.classList.toggle('hidden');
            e.target.classList.toggle('shown');
            e.target.innerHTML = '&#9660;' + e.target.innerHTML.slice(1);
          } else {
            e.target.classList.toggle('hidden');
            e.target.classList.toggle('shown');
            e.target.innerHTML = '&#9658;' + e.target.innerHTML.slice(1);
          }
        });
      });

      document.querySelectorAll('div#foundData table').forEach(tabla => {
        tabla.addEventListener('click', (evt) => {

          if (!evt.target.parentNode.parentNode.parentNode.classList.contains('active')) {
            if (document.querySelectorAll('table.active')[0]) {
              document.querySelectorAll('table.active')[0].classList.remove('active');
            }

            tabla.classList.add('active');
            let layerName = tabla.id.split('.')[0].replace('tab_', '');

            // let layerName = tabla.dataset.featureId.split('.')[0];
            let idFeature = tabla.dataset.featureId;

            if ((this.map_.getWFS({ name: layerName }).length == 0) && (this.map_.getGeoJSON({ name: layerName }).length == 0)) {
              layerName += 'JSON';
            }


            let layerSelected = this.map_.getLayers({ name: layerName })[0];

            let featureSelected = layerSelected.getFeatureById(idFeature);
            let extent = featureSelected.getImpl().getOLFeature().getGeometry().extent_;
            if ((extent[0] == extent[2]) && (extent[1] == extent[3])) { // si es un punto aumentamos la extensión para que aparezca a una escala aceptable 
              extent[0] -= 100;
              extent[1] -= 100;
              extent[2] += 100;
              extent[3] += 100;
            }


            let coordFeature = featureSelected.getGeometry().coordinates;
            let featureType = featureSelected.getGeometry().type;
            let distPoint = false;
            let point;
            let coor = featureSelected.getCentroid().getImpl().olFeature_.values_.geometry.flatCoordinates;

            //  CORREGIMOS LAS COORDENADAS DEL CENTROIDE PARA QUE SIEMPRE ESTÉN DENTRO DEL ELEMENTO SELECCIONADO

            if (featureType == 'MultiLineString') {
              coordFeature.forEach((tramo) => {
                tramo.forEach((punto) => {
                  if (!distPoint) {
                    distPoint = this.calculateDistance(coor, punto);
                    point = punto;
                  } else {
                    if (distPoint > this.calculateDistance(coor, punto)) {
                      distPoint = this.calculateDistance(coor, punto);
                      point = punto;
                    }
                  }
                });
              });
              coor = point;
            }



            if (featureType == 'MultiPolygon') {
              let borders = this.calculateBorders(coor, coordFeature);

              //  SI EL CENTROIDE NO ESTA DENTRO DEL MULTIPOLIGONO CORREGIMOS SU POSICIÓN
              if (!this.compTopology(borders)) {
                if (borders.length != 0) {
                  if ((borders.filter(obj => obj.type == 'izquierda').length == 0) && (borders.filter(obj => obj.type == 'derecha').length == 0)) {
                    let bordersAba = borders.filter(obj => obj.type == 'abajo');
                    let bordersArri = borders.filter(obj => obj.type == 'arriba');
                    let distAba = null;
                    let distArri = null;

                    if (bordersAba.length != 0) {
                      distAba = Math.abs(((bordersAba[bordersAba.length - 1].coord[1] + bordersAba[bordersAba.length - 2].coord[1]) / 2) - coor[1]);
                    }
                    if (bordersArri.length != 0) {
                      distArri = Math.abs(((bordersArri[0].coord[1] + bordersArri[1].coord[1]) / 2) - coor[1]);
                    }

                    if ((distArri != null) && (distAba != null)) {
                      if (distAba >= distArri) {
                        coor[1] = (bordersArri[0].coord[1] + bordersArri[1].coord[1]) / 2;
                      } else {
                        coor[1] = (bordersAba[bordersAba.length - 1].coord[1] + bordersAba[bordersAba.length - 2].coord[1]) / 2;
                      }
                    } else {
                      if (distArri != null) {
                        coor[1] = (bordersArri[0].coord[1] + bordersArri[1].coord[1]) / 2;
                      }
                      if (distAba != null) {
                        coor[1] = coor[1] = (bordersAba[bordersAba.length - 1].coord[1] + bordersAba[bordersAba.length - 2].coord[1]) / 2;
                      }
                    }

                  } else {
                    let bordersI = borders.filter(obj => obj.type == 'izquierda');
                    let bordersD = borders.filter(obj => obj.type == 'derecha');
                    let distI = null;
                    let distD = null;

                    if (bordersI.length != 0) {
                      distI = Math.abs(((bordersI[bordersI.length - 1].coord[0] + bordersI[bordersI.length - 2].coord[0]) / 2) - coor[0]);
                    }

                    if (bordersD.length != 0) {
                      distD = Math.abs(((bordersD[0].coord[0] + bordersD[1].coord[0]) / 2) - coor[0]);
                    }

                    if ((distI != null) && (distD != null)) {
                      if (distI >= distD) {
                        coor[0] = (bordersD[0].coord[0] + bordersD[1].coord[0]) / 2;
                      } else {
                        coor[0] = (bordersI[bordersI.length - 1].coord[0] + bordersI[bordersI.length - 2].coord[0]) / 2;
                      }
                    } else {
                      if (distD != null) {
                        coor[0] = (bordersD[0].coord[0] + bordersD[1].coord[0]) / 2;
                      }
                      if (distI != null) {
                        coor[0] = (bordersI[bordersI.length - 1].coord[0] + bordersI[bordersI.length - 2].coord[0]) / 2;
                      }
                    }

                  }
                } else {
                  let subPoligono = [];
                  coordFeature.forEach((poligono) => {
                    if (poligono.length > subPoligono.length) {
                      subPoligono = poligono;
                    }
                  });

                  let centroide = [0, 0];

                  subPoligono[0].forEach((point) => {
                    centroide[0] += point[0];
                    centroide[1] += point[1];
                  });
                  centroide[0] = centroide[0] / subPoligono[0].length;
                  centroide[1] = centroide[1] / subPoligono[0].length;
                  coor = centroide;
                }

              }

            }


            if (this.SeleccionElementos_layer.getFeatures()[0]) {
              this.SeleccionElementos_layer.removeFeatures(this.SeleccionElementos_layer.getFeatures()[0]);
              this.SeleccionElementos_layer.clearStyle();
            }

            if ((featureSelected.getGeometry().type == 'Point') || (featureSelected.getGeometry().type == 'MultiPoint')) {
              this.SeleccionElementos_layer.setStyle(this.style_select_feature_table_point);
              featureSelected = false; // si la capa es puntual ya es una capa JSON y no duplicamos el feature en la capa SeleccionElementos_layer              

            } else if ((featureSelected.getGeometry().type == 'LineString') || (featureSelected.getGeometry().type == 'MultiLineString')) {
              this.SeleccionElementos_layer.setStyle(this.style_select_feature_table_line);
            } else if ((featureSelected.getGeometry().type == 'Polygon') || (featureSelected.getGeometry().type == 'MultiPolygon')) {
              this.SeleccionElementos_layer.setStyle(this.style_select_feature_table_polygon);
            }

            //  ELIMINAMOS CUALQUIER POPUP ANTERIORMENTE INSERTADO Y SELECCIONAMOS EL FEATURE EN LAS COORDENADAS YA CORREGIDAS

            if (this.map_.getPopup()) {
              this.map_.removePopup();
            }

            if (featureSelected) {
              this.SeleccionElementos_layer.addFeatures([featureSelected]);
              if (this.SeleccionElementos_layer.getImpl().extract) {
                this.map_.getFeatureHandler().selectFeatures([featureSelected], this.SeleccionElementos_layer, { coord: coor });
              }
            } else {
              this.map_.getFeatureHandler().selectFeatures([layerSelected.getFeatureById(idFeature)], layerSelected, { coord: coor });
            }
            setTimeout(() => {
              this.map_.setBbox(extent);
            }, 10);
          }
        });
      });

      document.querySelectorAll('button.downLoadCSV').forEach((button) => {
        button.addEventListener('click', (evt) => {
          let nameLayerToDownload = evt.target.dataset['download'];
          let layerToDownload = this.map_.getWFS({ name: nameLayerToDownload });
          let featuresToDownload = [];
          if (layerToDownload.length != 0) {    //    Capa WFS
            let features = foundFeatures.filter(obj => obj.layer == nameLayerToDownload)[0].features;
            features.forEach((feature) => {
              featuresToDownload.push(layerToDownload[0].getFeatureById(feature.idJSON).getGeoJSON());
            });
          } else {    //  Capa GeoJSON
            layerToDownload = this.map_.getGeoJSON({ name: nameLayerToDownload });
            if (layerToDownload.length != 0) {
              let features = foundFeatures.filter(obj => obj.layer == nameLayerToDownload)[0].features;
              features.forEach((feature) => {
                featuresToDownload.push(layerToDownload[0].getFeatureById(feature.idJSON).getGeoJSON());
              });
            } else {  //  Capa WMS
              nameLayerToDownload += 'JSON';
              layerToDownload = this.map_.getGeoJSON({ name: nameLayerToDownload });
              let features = layerToDownload[0].getFeatures();
              features.forEach((feature) => {
                featuresToDownload.push(feature.getGeoJSON());
              });
            }
          }
          if (nameLayerToDownload.slice(-4) == 'JSON') {
            nameLayerToDownload = nameLayerToDownload.slice(0, -4);
          }
          this.downloadCSV({ filename: nameLayerToDownload + ".csv", data: featuresToDownload });
        });

      });

    } else {
      this.foundData.innerHTML += '<p style="text-align: center; font-size: 15px;">No se han encotrado datos para la zona seleccionada</p>';
    }

    document.getElementById('contenedor_cargandoPagina').remove();

  }

  calculateDistance(centroid, point) {
    let dist = Math.pow(Math.pow(centroid[0] - point[0], 2) + Math.pow(centroid[1] - point[1], 2), 0.5);
    return dist
  }

  calculateBorders(centroid, multipoligon) {

    let array_fronteras = [];
    let vertical = false;

    multipoligon.forEach((multipoligon_part) => {
      multipoligon_part.forEach((poligon) => {
        if (!vertical) {

          for (let i = 1; i < poligon.length; i++) {
            // CALCULAMOS LAS INTERSECCIONES CON LA RECTA HORIZONTAL QUE PASA POR EL CENTROIDE Y SI ESTÁN A DERECHA O IZQUIERDA DEL CENTROIDE
            if ((poligon[i][1] <= centroid[1] && poligon[i - 1][1] >= centroid[1]) || (poligon[i][1] >= centroid[1] && poligon[i - 1][1] <= centroid[1])) {
              let frontera = new Object();
              frontera.coord = [];
              let coordX = (((poligon[i - 1][0] - poligon[i][0]) / (poligon[i - 1][1] - poligon[i][1])) * (centroid[1] - poligon[i][1])) + poligon[i][0];
              frontera.coord.push(coordX);
              frontera.coord.push(centroid[1]);

              if (centroid[0] > coordX) {
                frontera.type = 'izquierda';
              } else {
                frontera.type = 'derecha';
              }
              array_fronteras.push(frontera);
            }
          }
        }

        if (array_fronteras.length == 0) {
          vertical = true;
        }

        //  SI NO ENCUENTRA NINGUNA INTERSECCION CON EJE PARALELO AL DE ABSCISAS PRUEBA CON UN EJE VERTICAL

        if (vertical) {
          for (let i = 1; i < poligon.length; i++) {
            // CALCULAMOS LAS INTERSECCIONES CON LA RECTA VERTICAL QUE PASA POR EL CENTROIDE Y SI ESTÁN A ENCIMA O DEBAJO DEL CENTROIDE
            if ((poligon[i][0] > centroid[0] && poligon[i - 1][0] < centroid[0]) || (poligon[i][0] < centroid[0] && poligon[i - 1][0] > centroid[0])) {
              let frontera = new Object();
              frontera.coord = [];
              let coordY = (((poligon[i][1] - poligon[i - 1][1]) / (poligon[i][0] - poligon[i - 1][0])) * (centroid[0] - poligon[i - 1][0])) + poligon[i - 1][1];
              frontera.coord.push(centroid[0]);
              frontera.coord.push(coordY);

              if (centroid[1] > coordY) {
                frontera.type = 'abajo';
              } else {
                frontera.type = 'arriba';
              }
              array_fronteras.push(frontera);
            }
          }
        }
      });

    });

    if (!vertical) {
      array_fronteras.sort((x, y) => x.coord[0] - y.coord[0]);
    } else {
      array_fronteras.sort((x, y) => x.coord[1] - y.coord[1]);
    }

    return array_fronteras;
  }

  compTopology(array_fronteras) {
    let estaDentro;
    let der = array_fronteras.filter(obj => obj.type == 'derecha').length;
    let izq = array_fronteras.filter(obj => obj.type == 'izquierda').length;
    let abaj = array_fronteras.filter(obj => obj.type == 'abajo').length;
    let arrib = array_fronteras.filter(obj => obj.type == 'arriba').length;

    // SI LAS FRONTERAS A DERECHA E IZQUIERDA SON PARES EL CENTROIDE ESTÁ FUERA DEL POLÍGONO
    // SI LAS FRONTERAS A DERECHA E IZQUIERDA SON IMPARES EL DENTROIDE ESTÁ DENTRO DEL POLÍGONO
    if (abaj == 0 && arrib == 0) {
      if (der % 2 == 0 && izq % 2 == 0) {
        estaDentro = false;
      } else {
        estaDentro = true;
      }
    } else {
      if (abaj % 2 == 0 && arrib % 2 == 0) {
        estaDentro = false;
      } else {
        estaDentro = true;
      }
    }

    return estaDentro;
  }

  convertArrayOfObjectsToCSV(args) {
    var result, ctr, keys, columnDelimiter, lineDelimiter, data;

    var wktGeometry

    let addWKTGeometry = this.addWKTGeometry;

    data = args.data || null;
    if (data == null || !data.length) {
      return null;
    }

    columnDelimiter = args.columnDelimiter || ';';
    lineDelimiter = args.lineDelimiter || '\n';

    keys = Object.keys(data[0].properties);

    result = '';
    result += keys.join(columnDelimiter);
    result += columnDelimiter + 'WKT';
    result += lineDelimiter;

    data.forEach((item) => {
      ctr = 0;
      keys.forEach((key) => {
        if (ctr > 0) result += columnDelimiter;

        if (item.properties[key]) {
          result += item.properties[key];
        } else {
          result += 'null';
        }

        ctr++;
      });

      wktGeometry = addWKTGeometry(item.geometry.type, item.geometry.coordinates);

      result += columnDelimiter + wktGeometry;

      result += lineDelimiter;
    });

    return result;
  }

  downloadCSV(args) {
    var data, filename, link;
    var csv = this.convertArrayOfObjectsToCSV({
      data: args.data,
      filename: args.filename
    });
    if (csv == null) return;

    filename = args.filename || 'export.csv';

    if (!csv.match(/^data:text\/csv/i)) {
      csv = 'data:text/csv;charset=utf-8,' + csv;
    }
    data = encodeURI(csv);

    link = document.createElement('a');
    link.setAttribute('href', data);
    link.setAttribute('download', filename);
    link.click();
  }

  addWKTGeometry(type, coordinates) {
    let geometry = type.toUpperCase() + '(';
    if (type == 'Point') {
      geometry += coordinates[0] + ' ' + coordinates[1] + ')';
    }

    if (type == 'MultiPoint') {
      coordinates.forEach((coordinate) => {
        geometry += coordinate[0] + ' ' + coordinate[1] + ',';
      });
      geometry = geometry.slice(0, -1) + ')';
    }
    if (type == 'LineString') {
      coordinates.forEach((coordinate) => {
        geometry += coordinate[0] + ' ' + coordinate[1] + ',';
      });
      geometry = geometry.slice(0, -1) + ')';
    }

    if (type == 'MultiLineString' || type == 'Polygon') {
      coordinates.forEach((coord) => {
        geometry += '(';
        coord.forEach((punto) => {
          geometry += punto[0] + ' ' + punto[1] + ',';
        });
        geometry = geometry.slice(0, -1) + '),';
      });
      geometry = geometry.slice(0, -1) + ')';
    }

    if (type == 'MultiPolygon') {
      coordinates.forEach((polygon) => {
        geometry += '(';
        polygon.forEach((elem) => {
          geometry += '(';
          elem.forEach((punto) => {
            geometry += punto[0] + ' ' + punto[1] + ',';
          });
          geometry = geometry.slice(0, -1) + '),';
        });
        geometry = geometry.slice(0, -1) + '),';
      });
      geometry = geometry.slice(0, -1) + ')';
    }

    return geometry;
  }

}
